import React from 'react';
import { LanguageSupportMixin } from '../mixins/shared/language_support_mixin';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';

const createReactClass = require('create-react-class');

const METERS_TO_MILES = 0.000621371;

const SearchResultItem = createReactClass({
  handleClick(url, dataType, e) {
    e.preventDefault();
    e.stopPropagation();
    _gaq.push(['_trackEvent', 'Site Search', this.props.term, this.props.data.slug, this.props.idx + 1]);
    this.props.handleItemClick(url, this.props.data, this.props.idx + 1);
  },
  formatTrailInfo() {
    let resultString = '';
    if (this.props.data.type == 'trail') {
      resultString += this.props.data.area_name;
      if (this.props.data.city_name != '') resultString += (resultString == '' ? '' : ', ') + this.props.data.city_name;
      if (this.props.data.state_name != '') resultString += (resultString == '' ? '' : ', ') + this.props.data.state_name;
      if (this.props.data.country_name != '' && this.props.data.country_id != 313)
        resultString += (resultString == '' ? '' : ', ') + this.props.data.country_name;
    }
    return resultString;
  },
  metersToMiles(length) {
    return Math.round(length * METERS_TO_MILES * 100) / 100;
  },
  metersToFormattedUserUnits(length) {
    if (this.props.displayMetric) return `${(length / 1000.0).toFixed(2)} km`;
    return `${this.metersToMiles(length)} mi`;
  },
  formatLocationInfo() {
    let resultString = '';
    if (this.props.data.type != 'trail') {
      if (this.props.data.type != 'area' || (this.props.data.area_type && this.props.data.area_type == 'C')) {
        if (this.props.data.city_name !== undefined && this.props.data.city_name != '' && this.props.data.city_name != null)
          resultString += (resultString == '' ? '' : ', ') + this.props.data.city_name;
      }
      if (this.props.data.state_name !== undefined && this.props.data.state_name != '' && this.props.data.state_name != null)
        resultString += (resultString == '' ? '' : ', ') + this.props.data.state_name;
      if (
        this.props.data.country_name != '' &&
        this.props.data.country_name != undefined &&
        (resultString == '' || this.props.data.country_name != 'United States')
      )
        resultString += (resultString == '' ? '' : ', ') + this.props.data.country_name;
    }
    return resultString;
  },
  createResultUrl() {
    switch (this.props.data.type) {
      case 'track':
        return `/explore/recording/${this.props.data.slug}`;
      case 'map':
        return `/explore/map/${this.props.data.slug}`;
      case 'list':
        return `/lists/${this.props.data.slug}`;
      default:
        return `/${this.props.data.slug}`;
    }
  },
  handleHover() {
    this.props.hoverHandle(this.props.idx);
  },
  render() {
    let formattedName = this.props.data.name;
    if (this.props.latLngForDisplayDistance) {
      const areaDistanceTo = L.latLng(this.props.data._geoloc.lat, this.props.data._geoloc.lng).distanceTo(
        L.latLng(this.props.latLngForDisplayDistance[0], this.props.latLngForDisplayDistance[1])
      );
      formattedName = `${formattedName}  (${this.metersToFormattedUserUnits(areaDistanceTo)})`;
    }
    const formattedTrailInfo = this.formatTrailInfo();
    const formattedLocationInfo = this.formatLocationInfo();
    const dataUrl = this.createResultUrl();
    let formattedUrl = null;
    let dataType = null;
    if (formattedUrl == null || this.props.data.type != 'trail') {
      formattedUrl = dataUrl;
      dataType = this.props.data.type;
    }
    const clickHandler = this.handleClick.bind(null, formattedUrl, dataType);

    let classes = 'algolia-hit';
    if (this.props.selected) classes += ' hit-selected';
    return (
      <div
        key={`search-result-item-${this.props.idx}`}
        className={classes}
        onMouseEnter={this.handleHover}
        onTouchStart={this.handleHover}
        onClick={clickHandler}
      >
        <a href={LanguageSupportMixin.wrapUrlSafe(formattedUrl)}>
          <span className={`hit-icon ${this.props.data.type}`} />
          <span className="search-text">
            <span className={`item-name-txt ${StringConstantsMixin.constants.XLATE.NONE}`} title={formattedName}>
              {formattedName}
            </span>
            <br />
            <span className={`trail-search-info ${StringConstantsMixin.constants.XLATE.NONE}`} title={formattedTrailInfo}>
              {formattedTrailInfo}
            </span>
            <span className={`location-search-info ${StringConstantsMixin.constants.XLATE.NONE}`} title={formattedLocationInfo}>
              {formattedLocationInfo}
            </span>
          </span>
        </a>
      </div>
    );
  }
});

export { SearchResultItem };
